
const data = [
    {
        id: 1,
        number: '5,567',
        text: 'Счастливых клиентов',
    },
    {
        id: 2,
        number: '1245',
        text: 'Продуктов на выбор',
    },
    {
        id: 3,
        number: '372',
        text: 'Продаж в день',
    },
    {
        id: 4,
        number: '20',
        text: 'Лет на рынке',
    },
];

export { data };